import { StepProgress } from "./StepProgress";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BoardCompany } from "./BoardCompany";

const Company = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const steps = [
    { number: 1, label: "General Info", isActive: true },
    { number: 2, label: "Advanced", isActive: false },
  ];

  const [activeStep, setActiveStep] = useState(steps[0]);

  useEffect(() => {
    const urlStep = parseInt(searchParams.get("section")) || 1;
    setActiveStep(steps[urlStep - 1]);
  }, []);

  const handleStepClick = (step) => {
    setActiveStep(step);
    const newParams = new URLSearchParams(searchParams.toString());
    newParams.set("section", step?.number);
    setSearchParams(newParams);
  };

  return (
    <>
      <div className="h-full">
        <BoardCompany steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} />
      </div>
    </>
  );
};

export default Company;
